<template>
  <li class="orders-history-list__item">
    <div class="orders-history-list__group">
      <p class="orders-history-list__title">{{ order.name }}
      </p>
      <div class="orders-history-list__policy">
        <slot></slot>
      </div>
    </div>
    <span class="orders-history-list__sum">{{ formatNumberWithSign(order.amount, '₴') }}</span>
  </li>
</template>

<script>
import { numberFormatter } from '@/shared/lib/number';

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  mixins: [ numberFormatter ],
};
</script>

<style lang="scss" scoped>
.orders-history-list {
  &__item {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__group {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
  }

  &__policy {
    display: flex;
    justify-content: flex-start;
  }

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
  }

  &__sum {
    font-family: inherit;
    font-size: 16px;
    font-weight: 700;
    color: #2AA63C;
    text-wrap: nowrap;

    @media (max-width: 550px) {
      margin-top: 8px;
    }
  }
}
</style>
